/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthMeResponse
 */
export interface AuthMeResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthMeResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AuthMeResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AuthMeResponse
     */
    lastName: string;
}

export function AuthMeResponseFromJSON(json: any): AuthMeResponse {
    return AuthMeResponseFromJSONTyped(json, false);
}

export function AuthMeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthMeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
    };
}

export function AuthMeResponseToJSON(value?: AuthMeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'first_name': value.firstName,
        'last_name': value.lastName,
    };
}

